import React from "react";
import { Eye, Camera } from "lucide-react";

const Portfolio = () => {
  const portfolioItems = [
    {
      id: 1,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/iwd6hkvn_Screenshot_20250503_151201_Instagram~2.jpg"
    },
    {
      id: 2,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/6f6ldcgp_1000003122.png"
    },
    {
      id: 3,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/r3jytk6e_1000003124.png"
    },
    {
      id: 4,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/oppw3xta_1000003126.png"
    },
    {
      id: 5,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/g1l306dr_1000003128.png"
    },
    {
      id: 6,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/ovrhxb6p_1000003130.png"
    },
    {
      id: 7,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/e9fw088a_1000003132.png"
    },
    {
      id: 8,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/il32swlu_1000003134.png"
    },
    {
      id: 9,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/2k2b5tlq_1000003136%20%281%29.png"
    },
    {
      id: 10,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/tgoq9kxc_1000003138.png"
    },
    {
      id: 11,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/7uw38nn5_1000003142%20%281%29.png"
    },
    {
      id: 12,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/t9afl30v_1000003144.png"
    },
    {
      id: 13,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/1js3cl14_1000007177.jpg"
    },
    {
      id: 14,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/qdhverx7_1000007178.jpg"
    },
    {
      id: 15,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/4npurqze_1000007179.jpg"
    },
    {
      id: 16,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/c1brd0wg_1000007180.jpg"
    },
    {
      id: 17,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/8w9zottl_Screenshot_20250503_151336_Instagram.jpg"
    },
    {
      id: 18,
      image: "https://customer-assets.emergentagent.com/job_culinary-elite/artifacts/hzp6nhm8_Screenshot_20250504_113617_Chrome%20%281%29.jpg"
    }
  ];

  return (
    <div className="page-portfolio">
      {/* Hero Section */}
      <section className="hero-section relative py-16 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-12"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1651630535674-198c08635719')"
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-bg-primary/95 to-bg-primary/90"></div>
        
        <div className="container text-center relative z-10">
          <h1 className="hero-large mb-6">Culinary Portfolio</h1>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            A showcase of signature dishes and memorable dining experiences. 
            Each creation tells a story of flavor, technique, and artistry.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section-padding">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {portfolioItems.map(item => (
              <div 
                key={item.id} 
                className="group relative overflow-hidden hover-lift bg-primary"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={item.image}
                    alt={`Portfolio item ${item.id}`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-all duration-300 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center text-white p-4">
                      <Eye className="w-8 h-8 mx-auto mb-2" />
                      <p className="body-small">View Details</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Professional Photo Note */}
      <section className="section-padding-small bg-accent">
        <div className="container text-center">
          <div className="max-w-3xl mx-auto">
            <Camera className="w-12 h-12 text-interactive-base mx-auto mb-6" />
            <h2 className="heading-2 mb-4">Professional Food Photography</h2>
            <p className="body-regular text-secondary mb-6">
              All portfolio images are professionally photographed to showcase the artistry 
              and attention to detail in every dish. Each plate represents hours of preparation 
              and a commitment to culinary excellence.
            </p>
            <p className="body-small text-light italic">
              *Portfolio images shown are representative examples. Actual presentations may vary 
              based on seasonal ingredients and client preferences.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding">
        <div className="container text-center">
          <h2 className="heading-1 mb-4">Ready to Create Your Own Masterpiece?</h2>
          <p className="body-large text-secondary mb-8 max-w-xl mx-auto">
            Let's design a custom menu that showcases your favorite flavors and creates 
            unforgettable memories for you and your guests.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact" className="btn-primary">
              Plan Your Menu
            </a>
            <a href="/services" className="btn-secondary">
              View Services
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;